import baseService from './baseService';

export const getOpenings = (payload) => baseService.get(`/member/job_browse?${payload}`);

export const getOpeningDetail = (openingId, currentUserId) =>
  baseService.get(`/member/job_browse/${openingId}?user_id=${currentUserId}`);

export const getReferralLink = (id, referral_type) => baseService.post('/referral_links', { id, referral_type });

export const getCopyLink = (id) => baseService.post('/copy_links', { company_id: id });

export const getSocialShareLink = (openingId) =>
  baseService.post('/member/integration_accounts/share_opening', {
    job_id: openingId,
  });
export const getSocialShareLinkCompany = (companyName) =>
  baseService.get(`/company_profiles/${companyName}/share_link`, {
    id: companyName,
  });

export const getMatchingContacts = (jobId, params) =>
  baseService.get(`/member/jobs/${jobId}/matching_contacts`, { params });

export const getMatchingJobs = (userContactId, params) =>
  baseService.get(`/member/user_contacts/${userContactId}/matching_jobs`, { params });
